import axios from 'axios';
import { getEnv } from '../envConfig';

function getAuthBaseUrl() {
    const { ENVIRONMENT } = getEnv();
    if (ENVIRONMENT === 'development') {
        return '/api/auth';
    }
    const { ENDPOINT } = getEnv();
    return `${ENDPOINT || ''}/api/auth`;
}

const authClient = axios.create({
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
    },
});

authClient.interceptors.request.use((config) => {
    config.baseURL = getAuthBaseUrl();
    return config;
});

export async function login({ username, password, otp }) {
    const response = await authClient.post('/login', { username, password, otp });
    return response.data;
}

export async function refreshSession() {
    const response = await authClient.post('/refresh');
    return response.data;
}

export async function logout() {
    await authClient.post('/logout');
}

export async function getSession() {
    const response = await authClient.get('/me');
    return response.data;
}
